import { put, select, call, all } from "@redux-saga/core/effects";
import { takeLatest } from "redux-saga/effects";
import { normalize } from "normalizr";
import { getToken, correspondants } from "../../utils/api";
import { 
  getCorrespondantRoutine,
  getCorrespondantsRoutine,
  postCorrespondantRoutine,
  putCorrespondantRoutine,
  deleteCorrespondantRoutine,
} from "./routines";
import { correspondant } from "./../schemas";



function* getCorrespondantSaga(action) {
  yield put(getCorrespondantRoutine.request())

  try {
    const token = yield select(getToken);

    const { data } = yield call(correspondants.get, token, action.payload.id);

    const normalizedData = yield call(normalize, data, correspondant);

    yield put(getCorrespondantRoutine.success(normalizedData));
  }
  catch(error) {
    console.log(error)
    yield put(getCorrespondantRoutine.failure(error));
  }

  yield put(getCorrespondantRoutine.fulfill());
}

function* watchGetCorrespondant() {
  yield takeLatest(getCorrespondantRoutine.TRIGGER, getCorrespondantSaga)
}

function* getCorrespondantsSaga(action) {
  yield put(getCorrespondantsRoutine.request())

  try {
    const token = yield select(getToken);

    const { data } = yield call(correspondants.gets, token);

    const normalizedData = yield call(normalize, data, [correspondant]);

    yield put(getCorrespondantsRoutine.success(normalizedData));
  }
  catch(error) {
    console.log(error)
    yield put(getCorrespondantsRoutine.failure(error));
  }

  yield put(getCorrespondantsRoutine.fulfill());
}

function* watchGetCorrespondants() {
  yield takeLatest(getCorrespondantsRoutine.TRIGGER, getCorrespondantsSaga)
}

function* postCorrespondantSaga(action) {

  yield put(postCorrespondantRoutine.request())

  try {

    const token = yield select(getToken);

    const { data } = yield call(correspondants.post, token, action.payload.values);

    const normalizedData = yield call(normalize, data, correspondant);

    yield put(postCorrespondantRoutine.success(normalizedData));

  }
  catch(error) {
    console.log(error)
    yield put(postCorrespondantRoutine.failure(error));
  } 

  yield put(postCorrespondantRoutine.fulfill());
}

function* watchPostCorrespondant() {
  yield takeLatest(postCorrespondantRoutine.TRIGGER, postCorrespondantSaga)
}

function* putCorrespondantSaga(action) {
  
  yield put(putCorrespondantRoutine.request())

  try {

    const token = yield select(getToken);

    const { data } = yield call(correspondants.put, token, action.payload.id, action.payload.values);

    const normalizedData = yield call(normalize, data, correspondant);

    yield put(putCorrespondantRoutine.success(normalizedData));

  }
  catch(error) {
    console.log(error)
    yield put(putCorrespondantRoutine.failure(error));
  }

  yield put(putCorrespondantRoutine.fulfill());
}

function* watchPutCorrespondant() {
  yield takeLatest(putCorrespondantRoutine.TRIGGER, putCorrespondantSaga)
}

function* deleteCorrespondantSaga(action) {

  console.log(action.payload)
  
  yield put(deleteCorrespondantRoutine.request())

  try {

    const token = yield select(getToken);

    const { data } = yield call(correspondants.delete, token, action.payload.id);

    const normalizedData = yield call(normalize, data, correspondant);

    Object.keys(normalizedData.entities).forEach(key => {
      if(normalizedData.entities[key][normalizedData.result])
        normalizedData.entities[key][normalizedData.result]._id = null
    })

    yield put(deleteCorrespondantRoutine.success(normalizedData));

  }
  catch(error) {
    console.log(error)
    yield put(deleteCorrespondantRoutine.failure(error));
  } 

  yield put(deleteCorrespondantRoutine.fulfill());
}

function* watchDeleteCorrespondant() {
  yield takeLatest(deleteCorrespondantRoutine.TRIGGER, deleteCorrespondantSaga)
}

function* watchCorrespondant() {
  yield all([
    watchGetCorrespondant(),
    watchGetCorrespondants(),
    watchPostCorrespondant(),
    watchPutCorrespondant(),
    watchDeleteCorrespondant(),
  ])
}

export default watchCorrespondant;